export const FEATURES_FR = {
}

export type TranslationSchema = typeof FEATURES_FR;
